// src/com/login/AppLogin.js
import React, { useState } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Button } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import HomeplusBigLogo from '../../asset/image/homeplus.svg';
import { useMutation} from '@apollo/client';
import { useSnackbar } from 'notistack';
import { ApiMsg, AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { AppLoginDict } from './AppLoginDict';
import { LOGIN_NEW_TOP, LOGIN_AS } from './AppLoginGql';
import UserSessionInfo from '../../value/UserSessionInfo';
import VzmTextField from '../../common/VzmTextField';
import InputUtil from '../../value/InputUtil';


const LogoBox = styled(Box)({marginBottom: '1rem', display:'flex', alignItems:'center', flexDirection:'column'});

const TopText = styled(Box)({
    fontSize: '4vw', fontWeight: 'bold', fontFamily: 'Times New Roman', fontStyle: 'italic',
});

const LoginBox = styled(Box)({padding:'0 5% 0 5%'});
const inputMap = AppLoginDict.inputMap;

/**
 * 로그인 화면.
 * @param {*} param0 
 * @returns 
 */
export default function AppLogin({
    onLoginSuccess
}) {
    const [input, setInput] = useState({...AppObject.emptyInputData});
    const { enqueueSnackbar } = useSnackbar();

    const [loginNewTop, responseLogin] = useMutation(LOGIN_NEW_TOP, {
        onCompleted: (data) => {onCompleteLogin(data)},
        onError: (error) => alert(error.message),
    });

    // 로그인(loginAs)
    const [loginAs, responseLoginAs] = useMutation(LOGIN_AS, {
        onCompleted: (data) => {onCompleteLogin(data)},
        onError: (error) => alert('로그인 오류: ' + error.message),
    });

    const onChangeValue = (id, value, error) => {
        setInput(InputUtil.reflectData(input, id, value, error, inputMap, false));
    };

    const onCompleteLogin = (data) => {
        /*
        if(data.loginNewTop) {
            if(data.loginNewTop.sessionNote === ApiMsg.OK) {
                const sessionInfo = UserSessionInfo.initFromUserObject(data.loginNewTop);
                // userInfoRepo(sessionInfo);
                enqueueSnackbar(sessionInfo.user.userName + '님 환영합니다.', {variant: 'success'});
                onLoginSuccess(sessionInfo);
            }
            else {
                alert('로그인 실패: ' + data.loginNewTop.sessionNote);
            }
        }
        */
        // loginAs 또는 loginNewTop 
        const res = data.loginAs ? data.loginAs : data.loginNewTop;

        if(res) {
            if(res.sessionNote === ApiMsg.OK) {
                const sessionInfo = UserSessionInfo.initFromUserObject(res);
                enqueueSnackbar(sessionInfo.user.userName + '님 환영합니다.', {variant: 'success'});
                onLoginSuccess(sessionInfo);
            }
            else {
                alert('로그인 실패: ' + res.sessionNote);
            }
        }


    };

    const onClickLogin = () => {
        if(!input.data.userId) {
            alert('아이디를 입력하세요.');
            return;
        }
        if(!input.data.password) {
            alert('사용자암호를 입력하세요.');
            return;
        }

        const goOn = window.confirm('휴대전화 접속 시 사용요금제에 따라 추가요금이 발생할 수 있습니다. 계속하시겠습니까?');

        if(goOn) {
            // [adminId].as_user.[userId] 분기 처리
            const userIdParts = input.data.userId.split('.as_user.');

            if(userIdParts.length === 2) {
                // 임의 사용자 로그인 실행: adminId, userId, adminPassword 세팅
                const paramAs = {
                    variables: {
                        adminId: userIdParts[0],
                        userId: userIdParts[1],
                        adminPassword: input.data.password
                    }
                };
                loginAs(paramAs);
            } else {
                // 일반 로그인 실행
                const param = {variables: {userId: input.data.userId, password: input.data.password}};
                /* const newInput = {...input};
                newInput.data.password = '';
                setInput(newInput); */
                loginNewTop(param);
            }
        }
    };

    const onClickLogoIfDev = () => {
        const isDev = window.location.href.indexOf('localhost') > 0;
        if(isDev) {
            const newInput = {...input};
            newInput.data.userId = 'home1';
            newInput.data.password = '4321';
            setInput(newInput);
        }
    }

    const renderTOP = () => {
        return(
            <TopText>
                <span style={{color:"red"}}>T</span>ransport &nbsp;
                <span style={{color:"orange"}}>O</span>peration &nbsp;
                <span style={{color:"green"}}>P</span>rogram
            </TopText>
        );
    };

    return(
        <Box style={{display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', flexDirection:'column'}}>
            <LogoBox>
                <img src={HomeplusBigLogo} alt="Homeplus"
                    onClick={onClickLogoIfDev}
                    style={{width:'60%',}}
                />
                {renderTOP()}
            </LogoBox>
            <LoginBox>
                <VzmTextField dict={inputMap.userId}
                    value={input.data.userId}
                    onChange={onChangeValue}
                    fullWidth={true}
                    inputProps={{autoComplete:"userId"}}
                    style={{marginBottom: '1rem'}}
                />
                <VzmTextField dict={inputMap.password}
                    value={input.data.password}
                    onChange={onChangeValue}
                    onEnterKey={()=>{if(input.data.password) onClickLogin()}}
                    fullWidth={true}
                    inputProps={{autoComplete: 'current-password'}}
                    style={{marginBottom: '1rem'}}
                />
                <Button variant={AppStyle.mui.contained} color={AppStyle.mui.primary}
                    size={AppWord.LARGE}
                    onClick={onClickLogin}
                    startIcon={<LoginIcon/>}
                    fullWidth
                    disabled={responseLogin.loading || responseLoginAs.loading}
                >
                    로그인
                </Button>
            </LoginBox>
        </Box>
    );
}
